import React, { useEffect, useState } from "react";
import usePresale from "../../../hooks/usePresale";
import Counter from "./../../../Components/Counter";
import { Splide, SplideSlide } from "@splidejs/react-splide";

import "@splidejs/react-splide/css";
import pdf from "../../../PDF/whitepaper.pdf";
export default function HeroSection() {
  const { round, preSaleRate, totalHardCap, ICOInfo } = usePresale();
  const [saleRound, setSaleRound] = useState([]);
  const [presaleRate, setPresaleRate] = useState(0);
  const [totalToken, setTotalToken] = useState(0);
  const [USDPrice, setUSDPrice] = useState(0);
  const [IcoInfo, setIcoInfo] = useState([]);

  useEffect(() => {
    const info = async () => {
      await preSaleRate().then((data) => {
        console.log(data);
        setPresaleRate(data);
      });
      await ICOInfo().then((data) => {
        console.log(data);
        setIcoInfo(data);
      });
      await round().then((data) => {
        console.log(data);
        setSaleRound(data);
      });
      await totalHardCap().then((data) => {
        console.log(data);
        setTotalToken(data);
      });
      // getLivePriceOfMarket("ETH").then((data) => setUSDPrice(data));
    };
    info();
  }, []);

  return (
    <div>
      <section class="lg:pt-[100px] py-[30px]">
        <div className="container lg:px-10 px-6">
          <div className="flex lg:flex-row gap-8  flex-col">
            <div className="flex-1 lg:order-1 order-2 lg:pr-[100px]">
              <p className="mb-5 font-bold lg:text-[16px] text-[16px]">
                Welcome To
              </p>
              <h3 className="text-transparent uppercase bg-clip-text bg-gradient-to-r from-[#6f30fd] to-[#45adf4]   xl:text-[50px] lg:text-[35px] md:text-[35px] text-[25px] font-bold mb-5">
                Global Mentor
              </h3>
              <p className="mb-3 xl:text-[16px] lg:text-[16px] text-[15px]">
                THE WORLD'S FIRST AI-POWERED PLATFORM SOLVES HR AND PERFORMANCE
                ISSUES WITH GLOBAL THINKER INPUT IN A GAMIFIED INTERACTIVE
                METAVERSE
              </p>
              <h6 className="font-bold  lg:text-[20px] text-[18px] mt-5">
                Pre-Sale {saleRound[0]} End
              </h6>

              <div className="flex justify-start">
                <Counter endDate={parseInt(saleRound[1])} />
              </div>
              <div className="flex md:flex-row flex-col gap-3 mt-[70px] ">
                <a
                  href={pdf}
                  download
                  target={"_blank"}
                  className="bg-[#751efe] border-[#751efe] font-bold max-w-[400px] text-center hover:bg-[#751efe] hover:text-white transition duration-300 border-[#041562] text-white border-2 rounded-[10px] px-8 py-2 uppercase"
                >
                  Whitepaper
                </a>
                
              </div>
            </div>
            <div className="flex-1 lg:order-2 order-1 mt-0">
              <div>
                <img src={process.env.PUBLIC_URL +'/assets/heroimg.svg'} className="hero-img"></img>
              </div>
              {/*<div>
                <Splide
                  options={{
                    rewind: true,
                    width: 800,
                    gap: "1rem",
                  }}
                  aria-label="My Favorite Images"
                >
                  <SplideSlide>
                    {" "}
                    <img
                      src={process.env.PUBLIC_URL + "/assets/Picture6.png"}
                      alt="Image 1"
                    />
                  </SplideSlide>
                  <SplideSlide>
                    {" "}
                    <img
                      src={process.env.PUBLIC_URL + "/assets/Picture3.png"}
                      alt="Image 1"
                    />
                  </SplideSlide>
                  <SplideSlide>
                    {" "}
                    <img
                      src={process.env.PUBLIC_URL + "/assets/Picture4.png"}
                      alt="Image 1"
                    />
                  </SplideSlide>
                  <SplideSlide>
                    {" "}
                    <img
                      src={process.env.PUBLIC_URL + "/assets/Picture5.png"}
                      alt="Image 1"
                    />
                  </SplideSlide>
                </Splide>
                </div>*/}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
